import React from 'react';
import cn from 'classnames';

const BurgerMenuItemThirdLevel = ({
  title,
  url,
  obfuscate,
  obfuscateDataUrl,
  count,
  attributes,
  classStyle,
}) => {
  const classFromBO = attributes?.class || '';
  const targetFromBO = attributes?.target || '';

  const label = (
    <>
      {title} {count && ` (${count})`}
    </>
  );

  return (
    <div className={cn('mobile-menu__item', classStyle)}>
      {obfuscate ? (
        <span className={cn('obfuscate', classFromBO)} data-link={obfuscateDataUrl} data-target={targetFromBO}>
          {label}
        </span>
      ) : (
        <a href={url} className={cn(classFromBO)} data-target={targetFromBO}>
          {label}
        </a>
      )}
    </div>
  );
};

export default BurgerMenuItemThirdLevel;
